import React from 'react';

import { LoomIcon } from '@atlaskit/temp-nav-app-icons/loom';

import { Products } from '../../constants';
import { GlobalShortcutsItem } from '../../types';

export default function loom(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <LoomIcon size="20" />,
		label: 'Loom',
		apsKey: Products.LOOM,
		fallbackUrl,
	};
}
